import { useLocation } from 'react-router';

export const useAfterLoggedInTarget = () => {
  const { state }: { state: unknown } = useLocation();
  if (
    typeof state === 'object' &&
    state &&
    'afterLoggedInTarget' in state &&
    typeof state.afterLoggedInTarget === 'string'
  ) {
    return state.afterLoggedInTarget;
  }
  return null;
};
